<template>
  <div class="nx-file-image-selector-wrapper">
    <label v-if="label" class="primary--text">
      {{ label }}
    </label>
    <div class="nx-file-image-selector">
      <v-card>
        <div class="image-placeholder grey lighten-3 grey--text" v-bind:class="{'icon-holder': hasFile}">
          <template v-if="hasFile">
            <v-icon
              v-html="iconFromExtension(hasFile.extension)"
            ></v-icon>
            <span
              v-html="hasFile.name"
            ></span>
          </template>
          <template v-else>
            <p class="text" v-show="!loading">{{ $t('message.file.selector.noFile') }}</p>
            <p class="text" v-show="loading">
              {{ $t('message.file.imageSelector.loading') }}
              <br>
              <v-progress-circular
                indeterminate
                color="secondary"
              ></v-progress-circular>
            </p>
          </template>
        </div>
        <v-card-actions>
          <v-layout row align-baseline justify-space-around>
            <nx-selector
              :label="label"
              :additionalFilters="processedFilters"
              :value="value"
              :title-length="titleLength"
              :disabled="disabled"
              v-bind="$attrs"
              @input="fileSelected"
              :allow-searcher="allowSearcher"
              :collection-id="collectionId"
              :error-messages="errorMessages"
            ></nx-selector>

            <v-tooltip top>
              <v-btn
                icon
                :disabled="disabled"
                slot="activator"
                @click="openFileUploadDialog"
              >
                <v-icon>file_upload</v-icon>
              </v-btn>
              <span>{{ $t('message.file.imageSelector.upload')}}</span>
            </v-tooltip>
          </v-layout>
        </v-card-actions>
      </v-card>
    </div>

    <nx-file-wizard
      :mimeType="mimeType"
      :active="openFileUpload"
      :disabled="disabled"
      :type="fileType"
      :size="size"
      :collectionId="collectionId"
      @dismiss="openFileUpload = false"
      @fileCreated="fileCreated"
    ></nx-file-wizard>


  </div>
</template>

<script>
import Loadable from '@/mixins/loadable';
import FileInput from '@/modules/file/mixins/file-upload';
import FileWizard from '@/modules/file/wizard/Wizard';
import FileSelector from '@/modules/file/selectors/Selector';

export default {
  name: 'nx-file-selector',
  mixins: [Loadable, FileInput],
  components: {
    [FileSelector.name]: FileSelector,
    [FileWizard.name]: FileWizard,
  },
  props: {
    errorMessages: {
      type: Array,
      default: () => [],
    },
    allowSearcher: {
      type: Boolean,
      default: false,
    },
    collectionId: {
      type: Number,
    },
    disabled: {
      type: Boolean,
    },
  },
};
</script>

<style lang="stylus">
.nx-file-image-selector-wrapper {
  margin-bottom: 20px;
  label {
    font-size: 12px;
  }
}

.nx-file-image-selector {
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  .image-placeholder {
    animation: fadeIn 1s;
    display: flex;
    padding-top: 22%;
    align-items: center;
    align-content: center;
    justify-content: center;
    height: 150px;
    .text {
      text-align: center;
      position: relative;
      margin-top: -22%;
      animation: fadeIn 1s;
    }
    &.icon-holder {
      display: flex;
      flex-direction: column;
      padding-top: 0;

      i {
        font-size: 120px;
      }
    }
  }
  .nx-file-selector {
    width: 93%;

    .v-input {
      margin-top: 5px;
    }

    .v-text-field__details {
      margin-bottom: 8px;
    }
    .v-input__append-inner {
      margin-top: 10px;
    }
  }
}
</style>
